var render, staticRenderFns
import script from "./SnapSlider.vue?vue&type=script&lang=ts"
export * from "./SnapSlider.vue?vue&type=script&lang=ts"
import style0 from "./SnapSlider.vue?vue&type=style&index=0&id=6effe192&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports